import React from "react";
import PublicationFeedItem from "../components/PublicationFeedItem";

const PublicationsSearchResult: React.FC<JQI.PublicationsSearchResultProps> = (props) => {
  return (
    <PublicationFeedItem {...props} />
  )
};

export default PublicationsSearchResult;